export function randomArrayIndex(arrayLength: number): number {
  return Math.floor(Math.random() * arrayLength);
}
